import React from 'react';


function SubcategoryListItem(props) {
    return (
        <li className="area-categories__item">
            <a
                className="listLink"
                href={props.subcategory.categoryUrl}
                target="_blank"
            >
                {props.subcategory.displayName}
            </a>
        </li>
    )
}

export default SubcategoryListItem;